<div class="card mv-list">
    <div class="card-body">
        <form [formGroup]="contractsForm">
            <!-- Toolbar -->
            <div class="mv-list__toolbar">
                <div class="mv-list__toolbar-end" *ngIf="!isAnyContractSelected() && !isAnyContractSupplySelected()">
                    <div class="mv-search">
                        <i class="far fa-magnifying-glass"></i>
                        <input type="text" class="form-control fs-7" name="search" placeholder="{{'CONTRACT_NUMBER' | translate}}" formControlName="contractNumber"/>
                    </div>

                    <button type="button" class="btn mv-filter-btn" [class.active]="filterOverlayIsOpen" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="filterOverlayIsOpen = !filterOverlayIsOpen">
                        <i class="far fa-sliders"></i>
                        {{'FILTER' | translate}}
                        <span *ngIf="activeFilterCount > 0" class="mv-filter-btn__count">{{ activeFilterCount }}</span>
                    </button>
                    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="filterOverlayIsOpen = !filterOverlayIsOpen" [cdkConnectedOverlayBackdropClass]="'opacity-0'" [cdkConnectedOverlayOpen]="filterOverlayIsOpen" [cdkConnectedOverlayPositions]="[connectedOverlayPositions]">
                        <div class="mv-filter-menu">
                            <div class="mv-filter-menu__field">
                                <div class="mv-filter-menu__label">{{'STATUS' | translate}}</div>
                                <is-multi-select [solidInput]="false" [options]="statusSelectOptions" formControlName="status" [emitChangeOnClose]="true" [menuHasSameWidthAsInput]="true" [requestOnFocus]="true"></is-multi-select>
                            </div>
                            <div class="mv-filter-menu__field">
                                <div class="mv-filter-menu__label">{{'PRODUCT' | translate}}</div>
                                <is-multi-select [DataSource$]="productSelect$" [requestOnFocus]="true" [queryable]="true" [solidInput]="false" [showInitials]="true" formControlName="product" [emitChangeOnClose]="true" [menuHasSameWidthAsInput]="true"></is-multi-select>
                            </div>
                        </div>
                    </ng-template>

                    <button type="button" class="btn btn-primary" (click)="onContractAccessRequest()">
                        <i class="far fa-plus"></i>
                        {{ 'REQUEST_ACCESS_TO_NEW_CONTRACT' | translate }}
                    </button>
                </div>

                <div class="mv-list__toolbar-end" *ngIf="isAnyContractSelected() || isAnyContractSupplySelected()">
                    <button type="button" class="btn btn-light" (click)="removeAllSelections()">
                        <i class="far fa-xmark"></i>
                        {{'REMOVE_SELECTED' | translate}}
                    </button>
                    <button type="button" class="btn btn-warning" (click)="openTicketPopup()">
                        <i class="far fa-headset"></i>
                        {{ 'ASK_SUPPORT_CHANGE' | translate }}
                    </button>
                </div>
            </div>

            <!-- Table -->
            <div class="mv-table-wrap">
                <table class="mv-table">
                    <thead>
                        <tr>
                            <th class="mv-col-check">
                                <mat-checkbox [disableRipple]="true" (change)="masterContractToggle()" [checked]="isAllContractsSelected()" [indeterminate]="isContractIndeterminate()"/>
                            </th>
                            <th class="mv-sortable" (click)="sortContractData('number')">
                                {{'NUMBER' | translate}}
                                <i class="fas" [ngClass]="getContractColumnSortDirectionClass('number')"></i>
                            </th>
                            <th class="mv-sortable" (click)="sortContractData('status')">
                                {{'STATUS' | translate}}
                                <i class="fas" [ngClass]="getContractColumnSortDirectionClass('status')"></i>
                            </th>
                            <th class="mv-sortable" (click)="sortContractData('product')">
                                {{'PRODUCT' | translate}}
                                <i class="fas" [ngClass]="getContractColumnSortDirectionClass('product')"></i>
                            </th>
                            <th class="mv-sortable" (click)="sortContractData('electricitySuppliesCount')">
                                {{'ELECTRICITY_SUPPLY_POINTS' | translate}}
                                <i class="fas" [ngClass]="getContractColumnSortDirectionClass('electricitySuppliesCount')"></i>
                            </th>
                            <th class="mv-sortable" (click)="sortContractData('naturalGasSuppliesCount')">
                                {{'NATURAL_GAS_SUPPLY_POINTS' | translate}}
                                <i class="fas" [ngClass]="getContractColumnSortDirectionClass('naturalGasSuppliesCount')"></i>
                            </th>
                            <th class="mv-sortable" (click)="sortContractData('selfConsumptionSuppliesCount')">
                                {{'AUTOCONSUMPTION_SUPPLY_POINTS' | translate}}
                                <i class="fas" [ngClass]="getContractColumnSortDirectionClass('selfConsumptionSuppliesCount')"></i>
                            </th>
                            <th class="mv-col-action"></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngIf="contracts.length == 0">
                            <td [colSpan]="8" class="mv-empty">
                                <i class="far fa-file-contract"></i>
                                {{ 'NO_CONTRACTS_ASSOCIATED' | translate }}
                            </td>
                        </tr>

                        <ng-container *ngFor="let contract of contractsPage">
                            <tr class="mv-row" [class.expanded]="isContractExpanded(contract)">
                                <td class="mv-col-check">
                                    <mat-checkbox [disableRipple]="true" (change)="toggleContractSelection(contract)" [checked]="isContractSelected(contract)"/>
                                </td>
                                <td>
                                    <a class="mv-link" [routerLink]="contract.guidId">{{contract.contractNumber | empty: '-'}}</a>
                                </td>
                                <td>
                                    <span class="mv-status" [ngClass]="'mv-status--' + getStatusColor(contract.status)">
                                        {{'CONTRACT_STATES.' + contract.status | translate}}
                                    </span>
                                </td>
                                <td>{{contract.supplierProductName | empty: '-'}}</td>
                                <td class="mv-num">{{contract.electricitySupplyContractsCount | empty: '-'}}</td>
                                <td class="mv-num">{{contract.naturalGasSupplyContractsCount | empty: '-'}}</td>
                                <td class="mv-num">{{contract.selfConsumptionContractsCount | empty: '-'}}</td>
                                <td class="mv-col-action">
                                    <button type="button" class="mv-icon-btn" [class.rotated]="isContractExpanded(contract)" (click)="toggleDetails(contract)">
                                        <i class="far fa-chevron-down"></i>
                                    </button>
                                </td>
                            </tr>

                            <tr *ngIf="isContractExpanded(contract)">
                                <td [colSpan]="8" class="mv-subtable-cell">
                                    <table class="mv-subtable">
                                        <thead>
                                            <tr>
                                                <th class="mv-col-check">
                                                    <mat-checkbox [disableRipple]="true" (change)="masterContractSupplyToggle(contract)" [checked]="isAllContractSuppliesSelected(contract)" [indeterminate]="isContractSupplyIndeterminate(contract)"/>
                                                </th>
                                                <th class="mv-sortable" (click)="sortContractData('equipmentCode')">
                                                    {{'EQUIPMENT_CODE' | translate}}
                                                    <i class="fas" [ngClass]="getContractColumnSortDirectionClass('equipmentCode')"></i>
                                                </th>
                                                <th class="mv-sortable" (click)="sortContractData('equipmentCounty')">
                                                    {{'CONSUMPTION_POINT' | translate}}
                                                    <i class="fas" [ngClass]="getContractColumnSortDirectionClass('equipmentCounty')"></i>
                                                </th>
                                                <th class="mv-sortable" (click)="sortContractData('product')">
                                                    {{'PRODUCT' | translate}}
                                                    <i class="fas" [ngClass]="getContractColumnSortDirectionClass('product')"></i>
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody *ngIf="!areContractSuppliesLoaded(contract)">
                                            <tr>
                                                <td [colSpan]="4" class="text-center py-10 position-relative">
                                                    <ngx-spinner [zIndex]="1000" [fullScreen]="false" bdColor="rgba(128, 128, 128, 0.6)" [size]="'small'" [name]="getContractSuppliesLoaderName(contract.guidId)" type="ball-spin-clockwise"></ngx-spinner>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody *ngIf="areContractSuppliesLoaded(contract) && getContractSupplies(contract) as supplies">
                                            <tr *ngIf="supplies.length == 0">
                                                <td [colSpan]="4" class="mv-empty mv-empty--compact"> {{ 'NO_CONTRACTS_ASSOCIATED' | translate }} </td>
                                            </tr>
                                            <tr *ngFor="let contractSupply of supplies">
                                                <td class="mv-col-check">
                                                    <mat-checkbox [disableRipple]="true" (change)="toggleContractSupplySelection(contractSupply)" [checked]="isContractSupplySelected(contractSupply)"/>
                                                </td>
                                                <td class="fw-semibold">{{getContractSupplyEquipmentCode(contractSupply) | empty: '-'}}</td>
                                                <td>{{getContractSupplyEquipmentCounty(contractSupply) | empty: '-'}}</td>
                                                <td>{{contractSupply.supplierProductName | empty: '-'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>

            <!-- Pagination -->
            <div class="mv-list__footer">
                <div class="mv-page-size">
                    {{ 'ROWS_PER_PAGE' | translate }}
                    <mat-select formControlName="pageSize" hideSingleSelectionIndicator="true">
                        <mat-option [value]="size" *ngFor="let size of paginationPageSizes">{{size}}</mat-option>
                    </mat-select>
                </div>

                <div class="mv-pager">
                    <span class="mv-pager__range">{{ 'RECORDS_RANGE' | translate: contractsRange }}</span>
                    <button type="button" class="mv-pager__btn" [disabled]="contractsForm.controls.page.value == 1" (click)="previousPage()">
                        <i class="far fa-chevron-left"></i>
                    </button>
                    <span class="mv-pager__current">{{contractsForm.controls.page.value}}</span>
                    <button type="button" class="mv-pager__btn" [disabled]="contractsForm.controls.page.value! >= contractsMaxPage" (click)="nextContractsPage()">
                        <i class="far fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- Footer Image - Redirect to Market Dealers -->
<div class="mv-banner">
    <a href="https://energia.mastervantagem.com/market-dealers-pt" target="_blank" rel="noopener">
        <img [src]="'assets/images/PortalDoCliente_Banner_MarketDealers.png'" alt="Market Dealers">
    </a>
</div>
